import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClaimSubmissionFooterButtons } from '../claim-submission.constant';
import { ClaimSubmissionFooterConfig } from '../claim-submission.model';

@Component({
  selector: 'lib-claim-submission-footer',
  templateUrl: './claim-submission-footer.component.html',
  styleUrls: ['./claim-submission-footer.component.scss'],
})
export class ClaimSubmissionFooterComponent {
  @Input() footerConfig: ClaimSubmissionFooterConfig;
  @Input() selectedTabIndex: number;
  @Input() ifFormValid: boolean;
  @Input() totalClaimLineCharges: number;
  @Input() submitButtonEnabled: boolean;
  @Output() footerButtonClicked: EventEmitter<string> = new EventEmitter();

  saveClaim() {
    this.footerButtonClicked.emit(ClaimSubmissionFooterButtons.save);
  }

  reviewClaim() {
    this.footerButtonClicked.emit(ClaimSubmissionFooterButtons.review);
  }

  submitClaim() {
    this.footerButtonClicked.emit(ClaimSubmissionFooterButtons.submit);
  }

  backToForm() {
    this.footerButtonClicked.emit(ClaimSubmissionFooterButtons.back);
  }
}
